import React, {
  memo,
  useMemo,
} from 'react';

import { formatName } from '../../../../shared/utils';
import { IUserShoutoutsFilters } from '../../../../types/tqConnectTypes/user';
import { UserAccountType } from '../../../../types/userTypes';
import NoDataFound from '../../../Feed/components/NoDataFound/NoDataFound';

interface Props {
  userName: string;
  viewerType: UserAccountType;
  isViewerSelf?: boolean;
  filters: IUserShoutoutsFilters;
}

const NoShoutouts: React.FC<Props> = ({ userName, isViewerSelf, filters }) => {
  const renderedNoShoutoutsContent = useMemo(() => {
    const { type } = filters;

    const firstName = formatName(userName, {
      nameType: 'first',
    });

    const title = `No shoutouts ${type === 'received' ? 'received' : 'given'} yet!`;
    const subtitle = isViewerSelf
      ? (type === 'received' &&
          'Once someone you help marks your service as complete and leaves feedback, their shoutouts will show up here.') ||
        'Shoutouts given by you will appear here.'
      : `Shoutouts ${type === 'received' ? 'received' : 'given'}  by ${firstName} will appear here.`;

    return <NoDataFound title={title} subtitle={subtitle} />;
  }, [filters, isViewerSelf, userName]);

  return renderedNoShoutoutsContent;
};

export default memo(NoShoutouts);
